export default "__VITE_ASSET__CovCQviH__"